import { Icon } from "@dmm-com/rocket-web-ui-library";
import { memo, useCallback, useState } from "react";
import * as Styled from "./style";
import { NextLink } from "~/components/blocks/common/next-link";
import { VideoMenus } from "~/components/blocks/layout/global-navi/desktop/left/dmm-menu/nav-menus/video-menu-item/video-menus";
import { isTouchDisplay } from "~/const/device";
import { PATHS } from "~/const/paths";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useOutsidePointerdown } from "~/hooks/use-outside-pointerdown";

type Props = {
  /** 選択中ならtrue */
  isActive: boolean;
};

export const VideoMenuItem = memo((props: Props) => {
  const { isActive } = props;

  const [isOpenVideoMenu, setIsOpenVideoMenu] = useState(false);
  const { handleClickByDevice } = useHandleClickByDevice();

  const openVideoMenu = useCallback(() => {
    setIsOpenVideoMenu(true);
  }, []);

  const closeVideoMenu = useCallback(() => {
    setIsOpenVideoMenu(false);
  }, []);

  const toggleVideoMenu = useCallback(() => {
    setIsOpenVideoMenu((prev) => !prev);
  }, []);

  const onClickVideoMenuIcon = useCallback(() => {
    if (!isTouchDisplay) return;
    toggleVideoMenu();
  }, [isTouchDisplay, toggleVideoMenu]);

  const { ref } = useOutsidePointerdown<HTMLLIElement>({
    onOutsidePointerDown: closeVideoMenu,
  });

  return (
    <Styled.LIList ref={ref}>
      <Styled.DivWrapper isActive={isActive} onMouseEnter={openVideoMenu} onMouseLeave={closeVideoMenu}>
        <NextLink href={PATHS.VOD} onClick={closeVideoMenu}>
          ビデオ
        </NextLink>
        {/* MEMO(uchida): ビデオトップに遷移後、「ビデオ」にカーソルがある状態から再度「▼アイコン」にホバーしたときにビデオメニューを表示するためonMouseEnterを設定 */}
        <Styled.ButtonIcon {...handleClickByDevice(onClickVideoMenuIcon)} onMouseEnter={openVideoMenu}>
          <Icon name="arrowDown" size="M" color="GRAY900" />
        </Styled.ButtonIcon>
        {isOpenVideoMenu && <VideoMenus closeVideoMenu={closeVideoMenu} />}
      </Styled.DivWrapper>

      {isOpenVideoMenu && <Styled.DivBackDrop {...handleClickByDevice(closeVideoMenu)} />}
    </Styled.LIList>
  );
});

VideoMenuItem.displayName = "VideoMenuItem";
